import React from 'react';
import ContentCard from '../Common/ContentCard';
import { assetUrl, formatDate, toExcerpt } from '../Common/useEntries';
import { eventCategory } from './eventFilters';

/**
 * Card for a single news item or press release. Every value shown comes from
 * the CMS entry — no category or tag is inferred.
 */
export default function EventCard({ event }) {
    if (!event?.fields) return null;

    const { title, slug, body, description, eventimage, date } = event.fields;
    const published = date || event.sys?.createdAt;

    return (
        <ContentCard
            title={title}
            description={toExcerpt(description || body, 150)}
            image={assetUrl(eventimage)}
            tag={eventCategory(event) || undefined}
            meta={[formatDate(published)]}
            to={`/eventdetails/${slug}`}
            cta="Read more"
        />
    );
}
